export function getSortedChildren(toSortObj) {
  const obj = Object.assign({}, toSortObj);
  const keys = Object.keys(obj).sort();
  for (let i=0;i < keys.length;i += 1) {
    if (obj[keys[i]] instanceof Array) {
      obj[keys[i]] = new Set(obj[keys[i]].slice());
    }
  }
  return obj;
}